import { render, staticRenderFns } from "./AsideComponent.vue?vue&type=template&id=3d55c66e&"
import script from "./AsideComponent.vue?vue&type=script&lang=js&"
export * from "./AsideComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports